import { render, staticRenderFns } from "./TransmissionSelector.vue?vue&type=template&id=5d25fde5"
import script from "./TransmissionSelector.vue?vue&type=script&lang=js"
export * from "./TransmissionSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports